export const ButtonType = {
  NONE: 'none',
  HOME: 'home',
  RETRY: 'retry',
  LINK: 'link',
  HREF: 'a',
};
